import { axiosInstance, requestConfig } from 'network/apis';

import { URL_UPLOAD } from 'utils/constants';

export const callImageUpload = async (data) => {
    const headers = { 'Content-Type': 'multipart/form-data' };

    return await axiosInstance(requestConfig('post', URL_UPLOAD, '/upload', data, headers));
};
